<script setup>
import { inject } from "vue";
const route = inject('route');
defineProps({
  routeName: String,
  componentName: String,
});
</script>
<template>
  <Link
    :href="route(routeName)"
    class="px-3 py-5 text-sm font-medium text-white-300 hover:bg-gray-500 hover:text-white"
    :class="{ 'bg-slate-600': $page.component === componentName }"
  >
    <slot />
  </Link>
</template>
